"use strict";

(function () {
  angular.module("sis-components.date", ["sis-components.date.constants", "sis-components.date.localDateEditor", "sis-components.date.localDateRangeEditor", "sis-components.date.localDateFormatFilter", "sis-components.date.previousDayFilter", "sis-components.date.yearRangeFilter", "sis-components.date.momentDateRangeFilter"]);
})();